/* ============================================================
   Ace Chef Apparels — Testimonial page system
   File: assets/ace-testimonials.js
   One shared runtime for every "Ace Testimonials — …" section.
   Data-attribute driven, idempotent, re-runs on section reload
   inside the theme editor. No dependencies.
   ============================================================ */
(function () {
  if (window.AceTM) { window.AceTM.init(); return; }

  var LS_VOTES = 'aceTM.votes';
  var LS_MINE  = 'aceTM.mine';
  var reduce   = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- tiny helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function once(el, flag) {
    if (!el || el.dataset['tmi' + flag] === '1') return false;
    el.dataset['tmi' + flag] = '1';
    return true;
  }
  function store(key) {
    try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch (e) { return {}; }
  }
  function save(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- 1. reveal on scroll ---------- */
  function reveal(root) {
    var els = $$('.tm-rev', root).filter(function (el) { return once(el, 'rev'); });
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseInt(el.getAttribute('data-tm-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, d);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. animated number count-up ---------- */
  function counters(root) {
    var els = $$('[data-tm-count-to]', root).filter(function (el) { return once(el, 'cnt'); });
    if (!els.length) return;

    function run(el) {
      var raw = el.getAttribute('data-tm-count-to') || '';
      var target = parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
      if (isNaN(target)) { return; }
      var dec = (String(raw).split('.')[1] || '').replace(/[^0-9]/g, '').length;
      var pre = el.getAttribute('data-tm-pre') || '';
      var suf = el.getAttribute('data-tm-suf') || '';
      if (reduce) { el.textContent = pre + target.toFixed(dec) + suf; return; }
      var dur = 1400, t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        var v = target * e;
        el.textContent = pre + (dec ? v.toFixed(dec) : Math.round(v).toLocaleString()) + suf;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        run(e.target); io.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3. rating breakdown bars ---------- */
  function bars(root) {
    var els = $$('[data-tm-bar]', root).filter(function (el) { return once(el, 'bar'); });
    if (!els.length) return;
    function fill(el) { el.style.width = (parseFloat(el.getAttribute('data-tm-bar')) || 0) + '%'; }
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(fill); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        fill(e.target); io.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 4. filter / sort / search / load-more ---------- */
  function filters(root) {
    $$('[data-tm-filterset]', root).forEach(function (set) {
      if (!once(set, 'flt')) return;

      var listSel = set.getAttribute('data-tm-list');
      var list    = listSel ? $(listSel, document) : $('[data-tm-list-target]', set);
      if (!list) return;

      var items   = $$('[data-tm-item]', list);
      var chips   = $$('[data-tm-filter]', set);
      var sortEl  = $('[data-tm-sort]', set);
      var starEl  = $('[data-tm-stars-filter]', set);
      var qEl     = $('[data-tm-search]', set);
      var countEl = $('[data-tm-count]', set);
      var emptyEl = list.parentNode ? $('[data-tm-empty]', list.parentNode) : null;
      var moreBtn = set.getAttribute('data-tm-more-target')
        ? $(set.getAttribute('data-tm-more-target'), document)
        : (list.parentNode ? $('[data-tm-more]', list.parentNode) : null);

      var step    = parseInt(set.getAttribute('data-tm-step') || '9', 10);
      var shown   = step;
      var cat     = 'all';

      items.forEach(function (el, i) { el.dataset.tmIndex = String(i); });

      function score(el) {
        return {
          cats: (el.getAttribute('data-cats') || '').toLowerCase(),
          rating: parseFloat(el.getAttribute('data-rating') || '0') || 0,
          date: el.getAttribute('data-date') || '',
          helpful: parseInt(el.getAttribute('data-helpful') || '0', 10) || 0,
          text: (el.getAttribute('data-text') || el.textContent || '').toLowerCase(),
          i: parseInt(el.dataset.tmIndex, 10)
        };
      }

      function apply(resetPage) {
        if (resetPage) shown = step;
        var minStar = starEl ? parseFloat(starEl.value || '0') || 0 : 0;
        var q = qEl ? qEl.value.trim().toLowerCase() : '';
        var sort = sortEl ? sortEl.value : 'featured';

        var keep = items.filter(function (el) {
          var s = score(el);
          if (cat !== 'all' && s.cats.indexOf('|' + cat + '|') === -1) return false;
          if (minStar && s.rating < minStar) return false;
          if (q && s.text.indexOf(q) === -1) return false;
          return true;
        });

        keep.sort(function (a, b) {
          var A = score(a), B = score(b);
          if (sort === 'recent') return (B.date || '').localeCompare(A.date || '') || A.i - B.i;
          if (sort === 'oldest') return (A.date || '').localeCompare(B.date || '') || A.i - B.i;
          if (sort === 'highest') return B.rating - A.rating || A.i - B.i;
          if (sort === 'lowest')  return A.rating - B.rating || A.i - B.i;
          if (sort === 'helpful') return B.helpful - A.helpful || A.i - B.i;
          return A.i - B.i;
        });

        items.forEach(function (el) { el.classList.add('tm-hidden'); });
        var vis = keep.slice(0, shown);
        vis.forEach(function (el) { el.classList.remove('tm-hidden'); });
        place(list, vis, items);

        if (countEl) {
          countEl.textContent = keep.length
            ? 'Showing ' + Math.min(shown, keep.length) + ' of ' + keep.length + (keep.length === 1 ? ' review' : ' reviews')
            : 'No reviews match those filters';
        }
        if (emptyEl) emptyEl.classList.toggle('tm-hidden', keep.length > 0);
        if (moreBtn) moreBtn.parentNode.classList.toggle('tm-hidden', keep.length <= shown);
        list.classList.toggle('tm-hidden', keep.length === 0);
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          cat = chip.getAttribute('data-tm-filter') || 'all';
          chips.forEach(function (c) { c.classList.toggle('is-on', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          apply(true);
        });
      });
      if (sortEl) sortEl.addEventListener('change', function () { apply(true); });
      if (starEl) starEl.addEventListener('change', function () { apply(true); });
      if (qEl) {
        var t;
        qEl.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { apply(true); }, 180); });
      }
      if (moreBtn) moreBtn.addEventListener('click', function () { shown += step; apply(false); });

      var rt;
      window.addEventListener('resize', function () {
        if (!list.hasAttribute('data-tm-masonry')) return;
        clearTimeout(rt);
        rt = setTimeout(function () {
          var n = masonCols(list);
          if (n !== list.__tmCols) apply(false);
        }, 180);
      });

      apply(true);
    });
  }

  /* how many masonry columns fit right now */
  function masonCols(list) {
    var want = parseInt(list.getAttribute('data-tm-masonry') || '3', 10) || 3;
    var w = list.clientWidth || window.innerWidth;
    if (w < 620) return 1;
    if (w < 980) return Math.min(2, want);
    return want;
  }

  /* put the visible items on the page, in order — plain list or JS masonry */
  function place(list, vis, all) {
    if (!list.hasAttribute('data-tm-masonry')) {
      vis.forEach(function (el) { list.appendChild(el); });
      return;
    }
    var n = masonCols(list);
    list.__tmCols = n;
    list.style.setProperty('--tm-n', n);

    var cols = $$(':scope > .tm-mcol', list);
    while (cols.length > n) { list.removeChild(cols.pop()); }
    while (cols.length < n) {
      var c = document.createElement('div');
      c.className = 'tm-mcol';
      list.appendChild(c);
      cols.push(c);
    }
    /* park everything that is hidden in the first column */
    all.forEach(function (el) {
      if (vis.indexOf(el) === -1 && el.parentNode !== cols[0]) cols[0].appendChild(el);
    });
    /* fill the shortest column each time so the wall stays balanced */
    var h = cols.map(function () { return 0; });
    vis.forEach(function (el) {
      var k = 0;
      for (var i = 1; i < n; i++) { if (h[i] < h[k]) k = i; }
      cols[k].appendChild(el);
      h[k] += el.offsetHeight + 20;
    });
  }

  /* ---------- 5. carousel rails ---------- */
  function rails(root) {
    $$('[data-tm-rail]', root).forEach(function (rail) {
      if (!once(rail, 'rail')) return;
      var id = rail.getAttribute('data-tm-rail');
      var wrap = rail.closest('[data-tm-railwrap]') || rail.parentNode;
      var prev = id ? document.querySelector('[data-tm-prev="' + id + '"]') : null;
      var next = id ? document.querySelector('[data-tm-next="' + id + '"]') : null;
      if (!prev) prev = $('[data-tm-prev]', wrap);
      if (!next) next = $('[data-tm-next]', wrap);

      function page() {
        var first = rail.firstElementChild;
        var w = first ? first.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
        return Math.max(w, Math.min(rail.clientWidth * 0.9, w * 2));
      }
      function sync() {
        if (!prev || !next) return;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -page(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: page(), behavior: reduce ? 'auto' : 'smooth' }); });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      setTimeout(sync, 60);

      /* pointer drag */
      var down = false, x0 = 0, s0 = 0, moved = 0;
      rail.classList.add('is-grab');
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; moved = 0; x0 = e.clientX; s0 = rail.scrollLeft;
        rail.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var d = e.clientX - x0;
        moved = Math.max(moved, Math.abs(d));
        rail.scrollLeft = s0 - d;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false; rail.classList.remove('is-dragging');
      });
      rail.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
      }, true);
    });
  }

  /* ---------- 6. lightbox ---------- */
  var lb = null, lbImg, lbCap, lbSet = [], lbAt = 0;
  function buildLB() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'tm-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Photo viewer');
    lb.innerHTML =
      '<button class="tm-lb__x" type="button" aria-label="Close">&times;</button>' +
      '<button class="tm-lb__nav is-prev" type="button" aria-label="Previous photo"><svg viewBox="0 0 16 16"><path d="M10 2L4 8l6 6"/></svg></button>' +
      '<img alt="">' +
      '<button class="tm-lb__nav is-next" type="button" aria-label="Next photo"><svg viewBox="0 0 16 16"><path d="M6 2l6 6-6 6"/></svg></button>' +
      '<p class="tm-lb__cap"></p>';
    document.body.appendChild(lb);
    lbImg = $('img', lb); lbCap = $('.tm-lb__cap', lb);
    $('.tm-lb__x', lb).addEventListener('click', closeLB);
    $('.is-prev', lb).addEventListener('click', function () { goLB(-1); });
    $('.is-next', lb).addEventListener('click', function () { goLB(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLB(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLB();
      if (e.key === 'ArrowLeft') goLB(-1);
      if (e.key === 'ArrowRight') goLB(1);
    });
  }
  function showLB() {
    var it = lbSet[lbAt];
    if (!it) return;
    lbImg.src = it.src;
    lbImg.alt = it.cap || 'Customer photo';
    lbCap.textContent = it.cap || '';
    var multi = lbSet.length > 1;
    $('.is-prev', lb).style.display = multi ? '' : 'none';
    $('.is-next', lb).style.display = multi ? '' : 'none';
  }
  function goLB(d) { lbAt = (lbAt + d + lbSet.length) % lbSet.length; showLB(); }
  function closeLB() { lb.classList.remove('is-open'); document.body.classList.remove('tm-lock'); }
  function zooms(root) {
    $$('[data-tm-zoom]', root).forEach(function (btn) {
      if (!once(btn, 'zoom')) return;
      btn.addEventListener('click', function () {
        buildLB();
        var group = btn.getAttribute('data-tm-group') || '';
        var peers = group
          ? $$('[data-tm-zoom][data-tm-group="' + group + '"]')
          : [btn];
        peers = peers.filter(function (p) { return !p.closest('.tm-hidden'); });
        if (peers.indexOf(btn) === -1) peers = [btn];
        lbSet = peers.map(function (p) {
          return { src: p.getAttribute('data-tm-zoom'), cap: p.getAttribute('data-tm-cap') || '' };
        });
        lbAt = Math.max(0, peers.indexOf(btn));
        showLB();
        lb.classList.add('is-open');
        document.body.classList.add('tm-lock');
      });
    });
  }

  /* ---------- 7. helpful votes ---------- */
  function votes(root) {
    var db = store(LS_VOTES);
    $$('[data-tm-vote]', root).forEach(function (btn) {
      if (!once(btn, 'vote')) return;
      var key = btn.getAttribute('data-tm-vote');
      var nEl = $('[data-tm-vote-n]', btn);
      var base = parseInt(btn.getAttribute('data-tm-vote-base') || '0', 10) || 0;

      function paint() {
        var on = !!db[key];
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (nEl) nEl.textContent = String(base + (on ? 1 : 0));
        var card = btn.closest('[data-tm-item]');
        if (card) card.setAttribute('data-helpful', String(base + (on ? 1 : 0)));
      }
      paint();
      btn.addEventListener('click', function () {
        db = store(LS_VOTES);
        if (db[key]) { delete db[key]; } else { db[key] = 1; }
        save(LS_VOTES, db);
        paint();
      });
    });
  }

  /* ---------- 8. share / copy link ---------- */
  function shares(root) {
    $$('[data-tm-share]', root).forEach(function (btn) {
      if (!once(btn, 'shr')) return;
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-tm-share') || window.location.href;
        var title = btn.getAttribute('data-tm-share-title') || document.title;
        var label = $('[data-tm-share-label]', btn);
        function flash(txt) {
          if (!label) return;
          var old = label.textContent;
          label.textContent = txt;
          btn.classList.add('is-copied');
          setTimeout(function () { label.textContent = old; btn.classList.remove('is-copied'); }, 1800);
        }
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
          return;
        }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { flash('Link copied'); }, function () {});
        }
      });
    });
  }

  /* ---------- 9. expand / collapse ---------- */
  function expanders(root) {
    $$('[data-tm-expand]', root).forEach(function (btn) {
      if (!once(btn, 'exp')) return;
      var panel = document.getElementById(btn.getAttribute('data-tm-expand'));
      if (!panel) return;
      var more = btn.getAttribute('data-tm-more-label') || 'Read the full story';
      var less = btn.getAttribute('data-tm-less-label') || 'Close';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', panel.id);
      btn.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var lab = $('[data-tm-expand-label]', btn);
        if (lab) lab.textContent = open ? less : more;
      });
    });
  }

  /* ---------- 10. small modal (partner blurbs) ---------- */
  var modal = null;
  function buildModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'tm-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="tm-modal__box">' +
      '<button class="tm-modal__x" type="button" aria-label="Close">&times;</button>' +
      '<img class="tm-modal__logo" alt="" hidden>' +
      '<h3 class="tm-modal__t"></h3>' +
      '<div class="tm-modal__b"></div>' +
      '</div>';
    document.body.appendChild(modal);
    $('.tm-modal__x', modal).addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }
  function closeModal() { modal.classList.remove('is-open'); document.body.classList.remove('tm-lock'); }
  function modals(root) {
    $$('[data-tm-modal-open]', root).forEach(function (el) {
      if (!once(el, 'mdl')) return;
      el.addEventListener('click', function () {
        buildModal();
        var logo = $('.tm-modal__logo', modal);
        var src = el.getAttribute('data-tm-modal-logo');
        if (src) { logo.src = src; logo.hidden = false; } else { logo.hidden = true; }
        $('.tm-modal__t', modal).textContent = el.getAttribute('data-tm-modal-title') || '';
        $('.tm-modal__b', modal).innerHTML = el.getAttribute('data-tm-modal-body') || '';
        modal.classList.add('is-open');
        document.body.classList.add('tm-lock');
      });
    });
  }

  /* ---------- 11. star picker ---------- */
  function starpick(root) {
    $$('[data-tm-starpick]', root).forEach(function (box) {
      if (!once(box, 'stp')) return;
      var input = $('[data-tm-starpick-input]', box) || document.getElementById(box.getAttribute('data-tm-starpick'));
      var label = $('[data-tm-starpick-label]', box);
      var btns = $$('button', box);
      var words = ['', 'Not for me', 'It was ok', 'Pretty good', 'Really good', 'Absolutely love it'];
      var value = parseInt(input && input.value ? input.value : '0', 10) || 0;

      function paint(n) {
        btns.forEach(function (b, i) { b.classList.toggle('is-on', i < n); b.setAttribute('aria-checked', i + 1 === value ? 'true' : 'false'); });
        if (label) label.textContent = n ? words[n] : 'Tap to rate';
      }
      btns.forEach(function (b, i) {
        b.addEventListener('mouseenter', function () { paint(i + 1); });
        b.addEventListener('focus', function () { paint(i + 1); });
        b.addEventListener('click', function () {
          value = i + 1;
          if (input) input.value = String(value);
          paint(value);
        });
      });
      box.addEventListener('mouseleave', function () { paint(value); });
      box.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        value = Math.min(5, Math.max(1, value + (e.key === 'ArrowRight' ? 1 : -1)));
        if (input) input.value = String(value);
        paint(value);
        if (btns[value - 1]) btns[value - 1].focus();
      });
      paint(value);
    });
  }

  /* ---------- 12. "my submissions" panel ---------- */
  function mine(root) {
    /* record a submission from the built-in form */
    $$('[data-tm-record]', root).forEach(function (form) {
      if (!once(form, 'rec')) return;
      form.addEventListener('submit', function () {
        var get = function (n) { var f = form.querySelector('[data-tm-field="' + n + '"]'); return f ? f.value : ''; };
        var list = store(LS_MINE);
        if (!list.items) list.items = [];
        list.items.unshift({
          id: 'tm' + Date.now(),
          title: get('title') || get('body').slice(0, 60) || 'Your review',
          product: get('product'),
          rating: get('rating'),
          at: new Date().toISOString().slice(0, 10),
          status: 'review'
        });
        list.items = list.items.slice(0, 12);
        save(LS_MINE, list);
      });
    });

    /* record a GoHighLevel embed submission (best effort) */
    $$('[data-tm-ghl-watch]', root).forEach(function (box) {
      if (!once(box, 'ghl')) return;
      window.addEventListener('message', function (e) {
        var o = String(e.origin || '');
        if (o.indexOf('leadconnectorhq.com') === -1 && o.indexOf('msgsndr.com') === -1) return;
        var d = e.data;
        var txt = typeof d === 'string' ? d : JSON.stringify(d || '');
        if (!/submit|success|thank/i.test(txt)) return;
        var list = store(LS_MINE);
        if (!list.items) list.items = [];
        if (list.items[0] && list.items[0].at === new Date().toISOString().slice(0, 10) && list.items[0].src === 'ghl') return;
        list.items.unshift({
          id: 'tm' + Date.now(),
          title: box.getAttribute('data-tm-ghl-watch') || 'Your testimonial',
          product: '', rating: '',
          at: new Date().toISOString().slice(0, 10),
          status: 'review', src: 'ghl'
        });
        save(LS_MINE, list);
        paintMine();
      });
    });

    paintMine(root);
  }

  function paintMine(root) {
    $$('[data-tm-mine]', root || document).forEach(function (panel) {
      var listEl = $('[data-tm-mine-list]', panel);
      var emptyEl = $('[data-tm-mine-empty]', panel);
      var clearEl = $('[data-tm-mine-clear]', panel);
      var data = store(LS_MINE);
      var items = (data.items || []);

      if (listEl) {
        listEl.innerHTML = items.map(function (it) {
          var meta = [];
          if (it.rating) meta.push(it.rating + '/5');
          if (it.product) meta.push(esc(it.product));
          meta.push('Sent ' + esc(it.at));
          return '<div class="tm-mine__row">' +
            '<div><div class="tm-mine__t">' + esc(it.title) + '</div>' +
            '<div class="tm-mine__d">' + meta.join(' &middot; ') + '</div></div>' +
            '<span class="tm-status' + (it.status === 'live' ? ' is-live' : '') + '">' +
            (it.status === 'live' ? 'Published' : 'In review') + '</span></div>';
        }).join('');
      }
      if (emptyEl) emptyEl.classList.toggle('tm-hidden', items.length > 0);
      if (listEl) listEl.classList.toggle('tm-hidden', items.length === 0);
      if (clearEl) {
        clearEl.classList.toggle('tm-hidden', items.length === 0);
        if (once(clearEl, 'clr')) {
          clearEl.addEventListener('click', function () {
            save(LS_MINE, { items: [] });
            paintMine();
          });
        }
      }
    });
  }

  /* ---------- 13. smooth anchor jumps (header is fixed) ---------- */
  function jumps(root) {
    $$('[data-tm-jump]', root).forEach(function (a) {
      if (!once(a, 'jmp')) return;
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var t = id && document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        var top = t.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        history.replaceState(null, '', '#' + id);
      });
    });
  }

  /* ---------- boot ---------- */
  function init(scope) {
    var root = scope || document;
    reveal(root); counters(root); bars(root); filters(root); rails(root);
    zooms(root); votes(root); shares(root); expanders(root); modals(root);
    starpick(root); mine(root); jumps(root);
  }

  window.AceTM = { init: init, refreshMine: paintMine };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
